<template>
    <div class="page">
        <div class="fill58"></div>

        <pageBreadcrumb :option="nav_option" />

        <div class="titleBigBox">
            <div class="wrap">
                <div class="topTitle">{{ lang == 'en' ? info.enTitle : info.title }}</div>
                <div class="line"></div>
                <div class="time">{{ info.dtTime }}</div>
                <div v-html="lang == 'en' ? info.enContent : info.content"></div>
            </div>
        </div>

        <div class="switchNews">
            <div class="wrap">
                <div class="switchPageBox">
                    <div class="switchPage" @click="changeNews(1)">
                        <div class="lastIcon"></div>
                        <div class="text">{{ $t('上一篇') }}：{{ lastNews ? lastNews.title : $t('没有了') }}</div>
                    </div>
                    <div class="switchPage2" @click="changeNews(2)">
                        <div class="text">{{ $t('下一篇') }}：{{ nextNews ? nextNews.title : $t('没有了') }}</div>
                        <div class="nextIcon"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="fill100"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'

export default {
    name: 'newsDetail',
    components: {
        pageBreadcrumb,
    },
    data() {
        return {
            nav_option: [
                { title: '首页', path: '/' },
                { title: '新闻动态', path: '/news' },
                { title: '新闻标题', path: '' },
            ],
            id: '', // 新闻id
            info: {},
            lastNews: null,
            nextNews: null,
        }
    },
    computed: {
        ...mapState([]),
    },
    watch: {
        '$route.query'() {
            window.location.reload()
        },
    },
    mounted() {
        this.id = this.$route.query.id
        this.nav_option = [
            { title: this.$t('首页'), path: '/' },
            { title: this.$t('新闻动态'), path: '/news' },
            { title: '新闻标题', path: '' },
        ]
        this.$load.open()
        this.$api({
            url: '/service.php',
            method: 'get',
            data: {
                action: 'news_detail',
                id: this.id,
            },
        }).then((res) => {
            this.$load.close()
            if (res.code == 200) {
                this.nav_option = [
                    { title: this.$t('首页'), path: '/' },
                    { title: this.$t('新闻动态'), path: '/news' },
                    { title: this.lang == 'en' ? res.data.info.enTitle : res.data.info.title, path: '' },
                ]
                this.info = res.data.info
                this.lastNews = res.data.last_news
                this.nextNews = res.data.next_news
            } else if (res.code == 500) {
                alertErr(res.msg)
            } else {
                alertErr('新闻详情获取失败')
            }
        })
    },
    methods: {
        // 文章切换
        changeNews(val) {
            if (val == 1) {
                // 上一篇
                if (this.lastNews) {
                    let id = this.lastNews.id
                    this.$router.push({
                        path: '/newsDetail',
                        query: {
                            id: id,
                        },
                    })
                }
            } else {
                // 下一篇
                if (this.nextNews) {
                    let id = this.nextNews.id
                    this.$router.push({
                        path: '/newsDetail',
                        query: {
                            id: id,
                        },
                    })
                }
            }
        },
    },
}
</script>

<style scoped lang="less">
.wrap {
    width: @width;
    overflow: hidden;
    margin: 0 auto;
}

.titleBigBox {
    width: 100%;

    .topTitle {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 35px;
        color: #000000;
        line-height: 34px;
    }

    .line {
        width: 100%;
        height: 2px;
        background: rgba(0, 0, 0, 0.8);
        margin: 20px 0;
    }

    .time {
        width: 100%;
        text-align: center;
        font-weight: 400;
        font-size: 16px;
        color: #888888;
        line-height: 25px;
        margin-bottom: 20px;
    }
}

.switchNews {
    margin-top: 93px;

    .switchPageBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .switchPage {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;

            .lastIcon {
                width: 36px;
                height: 36px;
                background: url('../../assets/img/news/last.png') no-repeat;
                background-size: 100% 100%;
            }

            .text {
                margin-left: 20px;
                font-weight: 400;
                font-size: 16px;
                color: #555555;
                line-height: 34px;
            }

            &:hover {
                .lastIcon {
                    background: url('../../assets/img/news/last2.png') no-repeat;
                    background-size: 100% 100%;
                }

                .text {
                    color: #ff4d00;
                }
            }
        }

        .switchPage2 {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            cursor: pointer;

            .nextIcon {
                width: 36px;
                height: 36px;
                background: url('../../assets/img/news/next.png') no-repeat;
                background-size: 100% 100%;
            }

            .text {
                margin-right: 20px;
                font-weight: 400;
                font-size: 16px;
                color: #555555;
                line-height: 34px;
            }

            &:hover {
                .nextIcon {
                    background: url('../../assets/img/news/next2.png') no-repeat;
                    background-size: 100% 100%;
                }

                .text {
                    color: #ff4d00;
                }
            }
        }
    }
}

.fill58 {
    width: 100%;
    height: 58px;
}

.fill100 {
    width: 100%;
    height: 100px;
}
</style>
<style scoped lang="less" src="@/assets/h5css/mobile/news.less"></style>
